const DEV = import.meta.env.DEV;

export const LANDING_URL = DEV
	? "http://localhost:5173"
	: "https://bodhistreams.com";
export const APP_URL = DEV
	? "http://localhost:5174"
	: "https://app.bodhistreams.com";
export const ADMIN_URL = DEV
	? "http://localhost:5175"
	: "https://admin.bodhistreams.com";
